import moment from "moment";

/**
 * 서버 시각 파서 (UTC-first 전환, 2026-09-22)
 *
 * 서버 응답은 두 가지가 섞여 온다.
 *  - 웹 전용 API: ISO-8601 UTC "2026-09-22T07:20:38Z" (오프셋 포함) → 실제 순간, 브라우저 시간대로 표시
 *  - 앱과 공용인 API(/api/graph/daily, /api/admin/users…): "yyyy-MM-dd HH:mm:ss" KST 벽시계 → +09:00 으로 해석
 * 어느 쪽이 와도 같은 순간의 moment(로컬)를 돌려주므로 화면은 이 함수만 쓰면 된다.
 * 🚨 문자열 substring/slice 로 날짜를 자르지 말 것(ISO 는 UTC 라 날짜가 어긋남). 상수 ±9h 금지.
 */
const ISO_WITH_OFFSET = /(?:[zZ]|[+-]\d{2}:?\d{2})$/;
const WALL_CLOCK = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?$/;
const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

export function parseServerTime(value) {
  if (value === null || value === undefined || value === "") return null;
  if (typeof value === "number") return moment(value); // epoch ms
  const s = String(value).trim();
  if (ISO_WITH_OFFSET.test(s)) return moment(s); // ISO(오프셋 포함) → 실제 순간
  if (WALL_CLOCK.test(s)) {
    // 오프셋 없는 벽시계 = 서버(KST) 기준으로 해석
    return moment(s.replace("T", " ").replace(/\.\d+$/, "") + " +09:00", ["YYYY-MM-DD HH:mm:ss Z", "YYYY-MM-DD HH:mm Z"]);
  }
  if (DATE_ONLY.test(s)) return moment(s, "YYYY-MM-DD"); // 날짜만(달력 값)은 그대로
  return moment(s);
}

/** 표시용. 파싱 실패/빈값이면 fallback. */
export function formatServerTime(value, fmt = "YYYY-MM-DD HH:mm:ss", fallback = "") {
  const m = parseServerTime(value);
  return m && m.isValid() ? m.format(fmt) : fallback;
}

export const formatServerMinute = (value, fallback = "") => formatServerTime(value, "YYYY-MM-DD HH:mm", fallback);

/** 브라우저 로컬 날짜 키(YYYY-MM-DD). 일자 그룹핑·매칭에 사용(ISO substring 대신). */
export const localDayKey = (value) => formatServerTime(value, "YYYY-MM-DD", null);

/** 서버로 보낼 때: 어떤 입력이든 ISO UTC "…Z" 로. (서버는 ISO/KST 문자열 둘 다 받지만 새 코드는 ISO 로) */
export function toServerIso(value) {
  const m = value && moment.isMoment(value) ? value : parseServerTime(value);
  return m && m.isValid() ? m.clone().utc().format("YYYY-MM-DDTHH:mm:ss[Z]") : null;
}
